import React, { useState } from "react";
import {
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";

const Example = props => {
  const [dropdownOpen, setOpen] = useState(false);

  const toggle = () => setOpen(!dropdownOpen);

  return (
    <ButtonDropdown
      isOpen={dropdownOpen}
      toggle={toggle}
      className="ic-button-dropdown"
    >
      <DropdownToggle
        caret
        size="sm"
        className="ic-dropdown-toggle"
        color="secondary"
      >
        Search IHI
      </DropdownToggle>
      <DropdownMenu>
        <DropdownItem onClick={props.handleSearchByIHI}>
          By IHI Number
        </DropdownItem>
        <DropdownItem onClick={props.handleSearchByMedicare}>
          By Medicare
        </DropdownItem>
        {/* <DropdownItem onClick={props.handleSearchByDVA}>By DVA</DropdownItem> */}
        <DropdownItem onClick={props.handleSearchByAddress}>
          By Address (Not Recommended)
        </DropdownItem>
      </DropdownMenu>
    </ButtonDropdown>
  );
};

export default Example;
